import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { AppVersionService } from '../../core/app-version.service';

@Component({
  selector: 'app-version-banner',
  templateUrl: './version-banner.component.html',
  styleUrls: ['./version-banner.component.scss'],
  standalone: false,
})
export class VersionBannerComponent {
  readonly updateAvailable$: Observable<boolean>;

  constructor(private readonly appVersionService: AppVersionService) {
    this.updateAvailable$ = this.appVersionService.updateAvailable$;
  }

  reload(): void {
    this.appVersionService.reload();
  }
}
